export default function Section16() {
    const processSteps = [
        {
            title: "Discovery, Strategy & Planning",
            description:
                "We begin by understanding your business goals, target audience, and competition within the UAE. Our team defines the project scope, required bilingual (English and Arabic) features, technical requirements, and establishes a detailed project timeline.",
        },
        {
            title: "Design & User Experience (UX)",
            description:
                "Our creative team designs a mobile-first, conversion-focused layout that appeals to UAE audiences. Once wireframes and mockups are approved, we refine the design to ensure it’s intuitive, visually engaging, and fully optimized for user interaction.",
        },
        {
            title: "Development, Integration & Testing",
            description:
                "Our Dubai-based developers build a fast, secure, and scalable WordPress platform using clean and efficient code. We integrate essential elements like UAE payment gateways, CRM tools, and VAT-compliant eCommerce functionality, followed by thorough testing on local servers.",
        },
        {
            title: "Client Review & Quality Assurance (QA)",
            description:
                "We provide a staging environment for your review and feedback. Our QA team runs final tests for performance, speed, mobile responsiveness, cross-browser compatibility, and security compliance before launch.",
        },
        {
            title: "Launch, Training & Ongoing Partnership",
            description:
                "Once approved, we ensure a smooth and risk-free launch. We train your team on managing your new WordPress website and provide continuous maintenance and performance monitoring to keep it optimized for the UAE market.",
        },
    ];

    return (
        <div className="Section16 py-[10px] md:py-[30px] bg-white">
            {/* Section Heading */}
            <div className="text-center mb-16 max-w-4xl mx-auto">
                <h2 className="text-[26px] md:text-[30px] font-bold text-[#151515] leading-[32px] md:leading-[41px]">
                    Our Seamless <span className="text-[#DA2128]">WordPress Development Process</span>
                </h2>
                <p className="mt-6 text-[#555] text-[16px] md:text-[18px] max-w-[700px] mx-auto">
                    We believe that every successful website starts with clear communication and a well-defined process. Our structured workflow ensures your WordPress project is delivered on time, within budget, and fully optimized for the UAE market.
                </p>
            </div>

            {/* Process Steps Grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 md:gap-12 w-[90%] md:w-[85%] mx-auto">
                {processSteps.map((step, index) => (
                    <div
                        key={index}
                        className={`p-6 rounded-2xl shadow-md text-left transition ${index % 2 === 0
                                ? "bg-[#E42E35] text-white"
                                : "bg-white text-[#151515] border border-gray-200"
                            }`}
                    >
                        <h3 className="text-[18px] md:text-[20px] font-bold mb-3">
                            {step.title}
                        </h3>
                        <p className="text-[14px] md:text-[15px] leading-[22px]">
                            {step.description}
                        </p>
                    </div>
                ))}
            </div>

           
        </div>
    );
}
